export default "__VITE_ASSET__Cf0JQ275__"